// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_c8-2";
export var aiChatCartContainerExit = "_c8-4";
export var aiChatContainerLarge = "_c8-0";
export var aiChatContainerSmall = "_c8-1";
export var aiChatIcon = "_c8-6";
export var slideInFromRight = "_c8-3";
export var slideOutToRight = "_c8-5";